// extracted by mini-css-extract-plugin
module.exports = {"text":"navigation_text_3ws","hidden":"navigation_hidden_1vE","root":"navigation_root_2y6"};